import Main from './components/Main';
import './App.css';

function App() {
  return (
    <div id = 'content'>
      <Main />
    </div>
  );
}

export default App;
